import { useEffect, useRef } from 'react'

import { useAppRouter as useRouter } from '@/shared/hooks/useAppRouter'

import { useSession } from '@/shared/services/session/compat'

import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'

import { initPH } from './phClient'

type Props = {
  disabled?: boolean
  pageviews?: boolean
}

export function AnalyticsInitializer({
  disabled = false,
  pageviews = true
}: Props) {
  const router = useRouter()
  const { data: session } = useSession()
  const { digitalProduct } = useDigitalProductContext()
  const lastEventSlug = useRef<string | null>(null)
  const lastUserId = useRef<string | null>(null)

  useEffect(() => {
    if (disabled) return
    const ph = initPH()
    if (!ph) return

    const userId =
      (session?.user as { id?: string | number } | undefined)?.id ??
      session?.user?.email ??
      null
    if (userId && userId !== lastUserId.current) {
      ph.identify(String(userId))
      ph.people.set({
        name: session?.user?.name,
        email: session?.user?.email
      })
      lastUserId.current = String(userId)
    }

    const eventSlug = digitalProduct?.slug ?? undefined
    if (eventSlug && eventSlug !== lastEventSlug.current) {
      ph.group('event_context', String(eventSlug), {
        id: digitalProduct?.id,
        slug: digitalProduct?.slug,
        name: digitalProduct?.name
      })
      lastEventSlug.current = String(eventSlug)
    }
  }, [
    disabled,
    pageviews,
    router.asPath,
    (session?.user as { id?: string | number } | undefined)?.id,
    session?.user?.email,
    digitalProduct?.id
  ])

  return null
}
